'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ui = require('../../../constants/events/ui');

var _ui2 = _interopRequireDefault(_ui);

var _fullScreen = require('./full-screen.view');

var _fullScreen2 = _interopRequireDefault(_fullScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FullScreenControl = function () {
  function FullScreenControl(_ref) {
    var eventEmitter = _ref.eventEmitter;

    _classCallCheck(this, FullScreenControl);

    this._eventEmitter = eventEmitter;
    this._isInFullScreen = null;

    this._bindCallbacks();

    this._initUI();

    this._bindEvents();

    this.setControlStatus(false);
  }

  _createClass(FullScreenControl, [{
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._toggleFullScreen = this._toggleFullScreen.bind(this);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_ui2.default.FULLSCREEN_STATUS_CHANGED, this.setControlStatus, this);
    }
  }, {
    key: '_initUI',
    value: function _initUI() {
      var config = {
        callbacks: {
          onToggleFullScreenButtonClick: this._toggleFullScreen
        }
      };

      this.view = new this.constructor.View(config);
    }
  }, {
    key: '_toggleFullScreen',
    value: function _toggleFullScreen() {
      if (this._isInFullScreen) {
        this._exitFullScreen();
      } else {
        this._enterFullScreen();
      }
    }
  }, {
    key: '_enterFullScreen',
    value: function _enterFullScreen() {
      this._eventEmitter.emit(_ui2.default.FULLSCREEN_ENTER_TRIGGERED);
    }
  }, {
    key: '_exitFullScreen',
    value: function _exitFullScreen() {
      this._eventEmitter.emit(_ui2.default.FULLSCREEN_EXIT_TRIGGERED);
    }
  }, {
    key: 'setControlStatus',
    value: function setControlStatus(isInFullScreen) {
      this._isInFullScreen = isInFullScreen;
      this.view.setState({ isInFullScreen: this._isInFullScreen });
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.isHidden = true;
      this.view.hide();
    }
  }, {
    key: 'show',
    value: function show() {
      this.isHidden = false;
      this.view.show();
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_ui2.default.FULLSCREEN_STATUS_CHANGED, this.setControlStatus, this);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.view.destroy();
      delete this.view;

      delete this._eventEmitter;

      delete this.isHidden;
    }
  }, {
    key: 'node',
    get: function get() {
      return this.view.getNode();
    }
  }]);

  return FullScreenControl;
}();

FullScreenControl.View = _fullScreen2.default;
exports.default = FullScreenControl;
//# sourceMappingURL=full-screen.controler.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/controls/full-screen/full-screen.controler.js
// module id = 1226
// module chunks = 1 2 3